<template>
  <div class="voice-talk-container" :class="isInWeixin ? 'is-in-weixin' : ''">
    <!-- 头部 -->
    <div class="voice-header">
      <span>
        <img :src="iconPaths.expand" alt="展开" @click="handleHistoryPopup" />
      </span>
      <span class="page-title">{{
        isCallActive && !isInitial ? "通话中..." : "语音对话"
      }}</span>
      <span>
        <img
          :src="require('@/assets/jsyl/jsyl-chat.png')"
          style="margin-right: 12px;"
          alt="新会话"
          @click="createNewCall"
        />
        <img
          src="@/assets/img/go_text.png"
          alt="切换到文本对话"
          @click="goToTextTalk"
        />
      </span>
    </div>

    <!-- 主体内容 -->
    <div class="voice-content" v-if="isInitial">
      <div class="avatar-container">
        <img src="@/assets/img/user_logo.png" alt="头像" class="avatar" />
      </div>
      <div class="greeting-text">
        <div class="greeting-title">Hi, 我是你的金融助手</div>
        <p>快开启语音对话和我聊聊吧</p>
      </div>
    </div>

    <!-- 通话中界面 -->
    <div class="call-container" v-else>
      <div class="call-in-progress" ref="callContainer">
        <div
          v-for="(item, index) in chatList"
          :key="index"
          :class="{
            'call-question': item.role === 'user',
            'call-answer': item.role === 'assistant',
          }"
        >
          <p>{{ item.content }}</p>
        </div>
      </div>
      <div class="scroll-gradient" v-if="showScrollGradient"></div>
    </div>

    <!-- 通话中底部控制区 -->
    <div class="call-controls" v-if="!isInitial">
      <template v-if="isCallActive">
        <div class="control-button" @click="toggleMute">
          <div class="control-button-icon" :class="{ 'is-muted': isMuted }">
            <img
              class="control-button-icon-img"
              :src="
                isMuted
                  ? require('@/assets/svg/audio_muted.svg')
                  : require('@/assets/svg/micphone.svg')
              "
              alt="麦克风"
            />
          </div>
          <p>{{ isMuted ? "已静音" : "麦克风" }}</p>
        </div>
        <div class="control-button end-call" @click="endCall">
          <div class="end-call-icon">
            <van-icon
              name="phone"
              class-prefix="close-phone van-icon van-icon-phone"
              size="28"
              color="#fff"
            />
          </div>
          <p>结束通话</p>
        </div>
        <div class="control-button" @click="toggleSpeaker">
          <div
            class="control-button-icon"
            :class="{ 'is-speaker-on': !isSpeakerOn }"
          >
            <img
              class="control-button-icon-img"
              :src="
                isSpeakerOn
                  ? require('@/assets/svg/voice.svg')
                  : require('@/assets/svg/ear.svg')
              "
              alt="扬声器"
            />
          </div>
          <p>{{ isSpeakerOn ? "扬声器" : "听筒" }}</p>
        </div>
      </template>
      <template v-else>
        <div class="call-button-container">
          <div class="call-button" @click="startCall">
            <van-icon name="phone" size="28" color="#fff" />
          </div>
          <p>开启语音对话</p>
        </div>
      </template>
    </div>
    <div class="call-button-container" v-if="isInitial">
      <div class="call-button" @click="startCall">
        <van-icon name="phone" size="28" color="#fff" />
      </div>
      <p>开启语音对话</p>
    </div>
    <div id="associate-popup-container"></div>
    <!-- 历史会话抽屉 -->
    <history-popup
      :visible="historyPopupVisible"
      :closeOnClickOverlay="true"
      ref="historyPopup"
      :activeChat="activeChat"
      :historyList="historyList"
      :loading="historyPopuploading"
      :refreshing="historyPopupRefreshing"
      :finished="historyPopupFinished"
      @close="historyPopupVisible = false"
      @refresh="onHistoryRefresh"
      @load="onHistoryLoad"
      @item-click="handleHistoryItemClick"
    ></history-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { AudioTextPair } from "./audioTextParis";
import HistoryPopup from "@/components/HistoryPopup.vue";
import { Dialog, Toast } from "vant";
import {
  createCall,
  getCallTranscripts,
  getCallSummary,
  addTranscript,
  getIndexData,
} from "@/api/theApi";
Vue.use(Dialog);
Vue.use(Toast);

let updateTimeout;
const wsUrl = "wss://voice.ainvestcn.com:9010";
export default {
  name: "VoiceTalk",
  components: {
    HistoryPopup,
  },
  data() {
    return {
      iconPaths: {
        expand: require("@/assets/jsyl/jsyl-expand.png"),
        more: null,
        avatar: null,
        phone: null,
        mic: null,
        endCall: null,
        speaker: null,
      },
      isInitial: !this.$route.params.id,
      historyPopupVisible: false,
      isCallActive: false,
      textSocket: null,
      audioContext: null,
      source: null,
      processor: null,
      micActive: true,
      isMuted: false,
      isSpeakerOn: true,
      gainNode: null,
      chatList: [],
      audioQueue: [],
      isPlaying: false,
      currentRealtimeText: "",
      fullSentences: [],
      realtimeSubtitles: "",
      callHistory: [],
      currentCallId: null,
      currentCall: null,
      loading: false,
      error: null,
      callDuration: 0,
      durationTimer: null,
      pairsHandler: new AudioTextPair(),
      historyList: [],
      historyPopuploading: false,
      historyPopupRefreshing: false,
      historyPopupFinished: false,
      activeChat: {
        chatId: "",
      },
      historyPageIndex: 1,
      historyPageSize: 10,
      showScrollGradient: false,
      isInWeixin: false,
    };
  },
  computed: {
    textServiceUrl() {
      // return location.origin === "https://yidao.ainvestcn.com"
      //   ? `${wsUrl}/service25`
      //   : `${wsUrl}/service27`;
	  return `${wsUrl}/service25`;
    },
    audioServiceUrl() {
      // return location.origin === "https://yidao.ainvestcn.com"
      //   ? `${wsUrl}/service26`
      //   : `${wsUrl}/service28`;
	  return `${wsUrl}/service26`;
    },
  },
  async mounted() {
    this.isInWeixin = /MicroMessenger/i.test(navigator.userAgent);
    this.currentCallId = this.$route.params.id;
    // this.getHistoryList();
    if (this.currentCallId) {
      this.activeChat.chatId = +this.currentCallId;
      this.isInitial = false;
      this.isCallActive = false;
      const { data } = await getCallTranscripts(this.currentCallId);
      this.chatList = (data || []).map((f) => {
        return {
          role: f.msgType === "question" ? "user" : "assistant",
          content: f.msgContent,
        };
      });

      // 添加滚动事件监听
      this.$nextTick(() => {
        if (this.$refs.callContainer) {
          this.$refs.callContainer.addEventListener("scroll", this.checkScroll);
          // 初始检查滚动状态
          this.checkScroll();
        }
      });
    }
  },
  beforeDestroy() {
    // 移除滚动事件监听
    if (this.$refs.callContainer) {
      this.$refs.callContainer.removeEventListener("scroll", this.checkScroll);
    }
  },
  methods: {
    createNewCall() {
      if (this.isInitial && !this.isCallActive) {
        return;
      } else {
        this.endCall(false);
        if (this.$route.params.id) {
          this.$router.replace("/jsyl/voiceTalk");
        } else {
          this.endCall(false);
          this.chatList = [];
          this.isInitial = true;
        }
      }
    },
    goToTextTalk() {
      this.stopTimer();
      this.endCall(false);
      this.$router.replace("/jsyl");
    },
    startTimer() {
      this.callDuration = 0;
      this.durationTimer = setInterval(() => {
        this.callDuration++;
      }, 1000);
    },
    stopTimer() {
      if (this.durationTimer) {
        clearInterval(this.durationTimer);
        this.durationTimer = null;
      }
    },
    handleHistoryPopup() {
      this.historyPopupVisible = !this.historyPopupVisible;
      if (this.historyPopupVisible) {
        // 刷新历史会话列表
        this.onHistoryRefresh();
      }
    },

    endCall(isShowoast = true) {
      this.isCallActive = false;
      this.stopTimer();

      // 清空实时字幕和相关文本
      this.realtimeSubtitles = "";
      this.currentRealtimeText = "";

      // 清空音频队列
      if (this.audioQueue && this.audioQueue.length) {
        this.audioQueue.forEach((item) => {
          if (item.url) {
            URL.revokeObjectURL(item.url);
          }
        });
        this.audioQueue = [];
      }

      // 重置播放状态
      this.isPlaying = false;

      // 关闭 WebSocket 连接
      if (this.textSocket) {
        this.textSocket.close();
        this.textSocket = null;
      }
      if (this.audioSocket) {
        this.audioSocket.close();
        this.audioSocket = null;
      }

      // 清理音频相关资源
      if (this.audioContext) {
        try {
          this.audioContext.close();
        } catch (error) {}
        this.audioContext = null;
      }

      if (this.gainNode) {
        try {
          this.gainNode.disconnect();
        } catch (error) {}
        this.gainNode = null;
      }

      if (this.processor) {
        try {
          this.processor.disconnect();
        } catch (error) {}
        this.processor = null;
      }

      if (this.source) {
        try {
          this.source.disconnect();
        } catch (error) {}
        this.source = null;
      }

      // 重置其他状态
      this.isSpeakerOn = true;
      this.isMuted = false;
      this.micActive = true;

      // 重置配对处理器
      this.pairsHandler = new AudioTextPair();

      if (isShowoast) {
        Toast.success("通话已结束");
      }
    },
    // 获取历史会话列表
    async getHistoryList() {
      const res = await getIndexData();
      if (res.code === 20000) {
        this.historyList = res.data.records;
        console.log("historyList", this.historyList);
      }
    },
    // 下拉刷新
    async onHistoryRefresh() {
      this.historyPopupRefreshing = true;
      this.historyPopupFinished = false;
      this.onHistoryLoad();
    },
    // 加载更多
    async onHistoryLoad() {
      // 如果是刷新操作，重置页码
      if (this.historyPopupRefreshing) {
        this.historyPageIndex = 1;
      }

      try {
        this.historyPopuploading = true;

        const res = await getIndexData({
          pageNum: this.historyPageIndex,
          pageSize: this.historyPageSize,
        });

        if (res.code === 20000) {
          // 合并新旧数据（分页追加）
          this.historyList = this.historyPopupRefreshing
            ? res.data.records
            : [...this.historyList, ...res.data.records];

          // 更新分页状态
          this.historyPopupFinished =
            res.data.records.length < this.historyPageSize;
          this.historyPageIndex++;
        }
      } catch (error) {
        console.error("加载历史记录失败", error);
      } finally {
        // 重置加载状态
        this.historyPopuploading = false;
        this.historyPopupRefreshing = false;
      }
    },
    // 处理列表项点击
    handleHistoryItemClick(item) {
      if (item.chatType === "voice") {
        this.$router.replace(`/jsyl/voiceTalk/${item.chatId}`);
      }
    },
    toggleSpeaker() {
      this.isSpeakerOn = !this.isSpeakerOn;

      // 调整音量
      if (this.gainNode) {
        this.gainNode.gain.value = this.isSpeakerOn ? 2.0 : 1;
      }

      Toast.success(this.isSpeakerOn ? "已切换到扬声器" : "已切换到听筒");
    },
    toggleMute() {
      this.isMuted = !this.isMuted;

      if (this.isMuted) {
        // 如果麦克风被静音，暂时断开音频处理
        if (this.processor && this.source) {
          this.source.disconnect(this.processor);
        }
        Toast.success("已静音");
      } else {
        // 如果取消静音，重新连接音频处理
        if (this.processor && this.source) {
          this.source.connect(this.processor);
        }
        Toast.success("已取消静音");
      }
    },
    async initAudioProcessing() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        this.audioContext = new AudioContext();
        this.source = this.audioContext.createMediaStreamSource(stream);
        this.processor = this.audioContext.createScriptProcessor(256, 1, 1);

        this.source.connect(this.processor);
        this.processor.connect(this.audioContext.destination);

        this.processor.onaudioprocess = (e) => {
          if (!this.micActive || !this.isCallActive || this.isMuted) return;

          const inputData = e.inputBuffer.getChannelData(0);
          const outputData = new Int16Array(inputData.length);

          for (let i = 0; i < inputData.length; i++) {
            outputData[i] = Math.max(
              -32768,
              Math.min(32767, inputData[i] * 32768)
            );
          }

          if (this.textSocket && this.textSocket.readyState === 1) {
            const metadata = JSON.stringify({
              sampleRate: this.audioContext.sampleRate,
            });
            const metadataBytes = new TextEncoder().encode(metadata);
            const metadataLength = new ArrayBuffer(4);
            const metadataLengthView = new DataView(metadataLength);
            metadataLengthView.setInt32(0, metadataBytes.byteLength, true);
            const combinedData = new Blob([
              metadataLength,
              metadataBytes,
              outputData.buffer,
            ]);

            this.textSocket.send(combinedData);
          }
        };
      } catch (error) {
        throw new Error("无法访问麦克风");
      }
    },
    async startCall() {
      try {
        this.isConnecting = true;

        // 初始化音频上下文（iOS需要）
        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          this.audioContext = new (window.AudioContext ||
            window.webkitAudioContext)();
          if (this.audioContext.state === "suspended") {
            await this.audioContext.resume();
          }
        }

        let textConnected;
        let audioConnected;
        if (!this.currentCallId) {
          const newCall = await this.startNewCall();
          //   await this.getHistoryList();
          // 连接 WebSocket
          textConnected = await this.connectToTextServer(newCall.chatId);
          audioConnected = await this.connectToAudioServer();
        } else {
          textConnected = await this.connectToTextServer(this.currentCallId);
          audioConnected = await this.connectToAudioServer();
        }

        if (textConnected && audioConnected) {
          await this.initAudioProcessing();

          // 使用 callStore 的 startNewCall 方法创建新通话
          this.startTimer();
          this.isCallActive = true;

          // 初始化通话总结

          Toast.success("通话已接通");
          this.isInitial = false;

          this.isCallActive = true;
        } else if (audioConnected) {
          Toast.fail("当前排队人数较多，请稍后再试");
        } else {
          throw new Error("WebSocket connection failed");
        }
      } catch (error) {
        console.error("Failed to start call:", error);
        Toast.fail("连接失败，请重试");
      } finally {
        this.isConnecting = false;
      }
    },

    // 添加 WebSocket 连接函数
    async connectToTextServer(call_id) {
      try {
        // 使用完整的 WebSocket URL
        this.textSocket = new WebSocket(
          `${this.textServiceUrl}?chat_id=${call_id}`
        );

        this.textSocket.onopen = () => {
          console.log("Text WebSocket connected");
        };

        this.textSocket.onerror = (error) => {
          console.error("Text WebSocket error:", error);
          Toast.fail("文本服务连接失败");
        };

        this.textSocket.onclose = () => {
          console.log("Text WebSocket closed");
        };

        this.textSocket.onmessage = (event) => {
          const data = JSON.parse(event.data);
          console.log("textSocket.onmessage", data);
          if (data.type === "error") {
            Toast.fail(data.message);
          } else if (data.type === "realtime") {
            // 累加实时文本，并更新为客服助手的回复
            this.realtimeSubtitles = data.text;
            this.pairsHandler.receiveText(data.text);
          } else if (data.type === "userSpeech") {
            const isNewSession =
              this.chatList.filter((f) => f.role === "user").length === 0;
            if (isNewSession) {
              createCall(data.text, this.currentCallId);
            }
            // 收到完整句子时，清空实时文本缓存
            this.currentRealtimeText = "";
            this.chatList.push({
              role: "user",
              content: data.text,
            });
            this.updateTranscript(data.text, "user", true);
            this.realtimeSubtitles = data.text;
          } else if (data.type === "fullSentence") {
            // 收到完整句子时，清空实时文本缓存
            this.currentRealtimeText = "";
            // this.chatList.push({
            //   role: "assistant",
            //   content: data.text,
            // });
            this.updateTranscript(data.text, "assistant", true);

            // 等待三秒后清空实时字幕
            setTimeout(() => {
              this.realtimeSubtitles = "";
            }, 3000);
          }
        };

        return true;
      } catch (error) {
        console.error("Error connecting to text server:", error);
        return false;
      }
    },

    async connectToAudioServer() {
      try {
        // 使用完整的 WebSocket URL
        this.audioSocket = new WebSocket(`${this.audioServiceUrl}`);

        this.audioSocket.onopen = () => {
          console.log("Audio WebSocket connected");
        };

        this.audioSocket.onerror = (error) => {
          console.error("Audio WebSocket error:", error);
          Toast.fail("音频服务连接失败");
        };

        this.audioSocket.onclose = () => {
          console.log("Audio WebSocket closed");
        };

        this.audioSocket.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);

            if (data.type === "audio") {
              if (!data.audioData || !data.format) {
                throw new Error("Invalid audio data received");
              }
              this.onAudioReceived(data.audioData, data.format);
            }
          } catch (error) {
            Toast.fail("音频消息处理失败");
          }
        };

        return true;
      } catch (error) {
        return false;
      }
    },
    // 添加base64转blob的辅助函数
    base64ToBlob(base64, type) {
      try {
        const byteCharacters = atob(base64);
        const byteArrays = [];
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArrays.push(byteCharacters.charCodeAt(i));
        }
        const byteArray = new Uint8Array(byteArrays);
        return new Blob([byteArray], { type });
      } catch (error) {
        return null;
      }
    },

    // 修改音频处理函数
    async onAudioReceived(audioData, format) {
      try {
        // 转换音频数据
        const blob = this.base64ToBlob(audioData, `audio/${format}`);
        if (!blob) {
          throw new Error("音频数据转换失败");
        }

        // 创建音频URL
        const url = URL.createObjectURL(blob);

        // 添加到队列
        this.audioQueue.push({
          url,
          blob,
        });

        // 添加到配对系统
        this.pairsHandler.receiveAudioUrl(url);

        // 如果没有正在播放，开始播放
        if (!this.isPlaying) {
          await this.playNextAudio();
        }
      } catch (error) {
        Toast.fail("音频处理失败");
      }
    },

    // 修改音频播放函数
    async playNextAudio() {
      if (
        this.isPlaying ||
        this.audioQueue.length === 0 ||
        !this.isCallActive
      ) {
        return;
      }

      try {
        this.isPlaying = true;
        this.micActive = false;
        this.isMuted = true;

        const audioItem = this.audioQueue[0];

        // 确保 AudioContext 已始化
        if (!this.audioContext) {
          this.audioContext = new (window.AudioContext ||
            window.webkitAudioContext)();
        }

        // 创建增益节点
        this.gainNode = this.audioContext.createGain();
        this.gainNode.connect(this.audioContext.destination);

        // 从 blob 创建 AudioBuffer
        const arrayBuffer = await audioItem.blob.arrayBuffer();
        const audioBuffer = await this.audioContext.decodeAudioData(
          arrayBuffer
        );

        // 创建音频源
        const source = this.audioContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(this.gainNode);

        // 设置音量（如果需要）
        this.gainNode.gain.value = this.isSpeakerOn ? 1.0 : 0.5;

        // 播放完成后的处理
        source.onended = () => {
          this.handlePlaybackEnd(audioItem.url);
        };

        // 获取对应的文本
        const text = this.pairsHandler.getTextByAudioUrl(audioItem.url);
        if (!this.currentRealtimeText) {
          this.chatList.push({
            role: "assistant",
            content: text,
          });
        }
        if (text) {
          this.realtimeSubtitles = text;
          this.currentRealtimeText += text;
          this.$set(this.chatList, this.chatList.length - 1, {
            role: "assistant",
            content: this.currentRealtimeText,
          });
          if (updateTimeout) {
            clearTimeout(updateTimeout);
          }
          updateTimeout = setTimeout(() => {
            console.log("updateTranscript", this.currentRealtimeText);
            this.updateTranscript(
              this.currentRealtimeText,
              "assistant",
              false,
              true
            );
          }, 3000);
        }

        // 开始播放
        source.start(0);
      } catch (error) {
        this.handlePlaybackEnd(
          this.audioQueue && this.audioQueue[0] && this.audioQueue[0].url
        );
      }
    },

    // 修改播放结束处理函数
    async handlePlaybackEnd(audioUrl) {
      if (audioUrl) {
        URL.revokeObjectURL(audioUrl);
        const index = this.audioQueue.findIndex(
          (item) => item.url === audioUrl
        );
        if (index > -1) {
          this.audioQueue.splice(index, 1);
        }
      }

      this.isPlaying = false;

      // 如果队列中还有音频，继续播放
      if (this.audioQueue.length > 0) {
        this.playNextAudio();
      } else {
        // 所有音频播放完成，恢复麦克风
        this.micActive = true;
        this.isMuted = false;
      }
    },

    // 开始新通话
    async startNewCall() {
      try {
        this.loading = true;

        // 创建新通话记录
        const response = await createCall();
        if (response.code !== 20000) {
          throw new Error("创建会话失败");
        }

        const newCall = response.data;
        this.chatList = [];
        // const newCall = {
        //   id: response.id,
        //   startTime: new Date().toISOString(),
        //   duration: 0,
        //   transcript: [],
        //   status: 'active',
        //   summary: null
        // }

        // callHistory.value.unshift(newCall)
        this.currentCallId = response.data.chatId;
        this.isCallActive = true;
        this.currentCall = response.data;

        return newCall;
      } catch (err) {
        this.error = "开始通话失败";
        Dialog.alert({
          title: this.error,
        });
        throw err;
      } finally {
        this.loading = false;
      }
    },
    async updateTranscript(
      text,
      role,
      isFullSentence = false,
      isRealtime = false
    ) {
      console.log("updateTranscript1", this.currentCallId);
      if (!this.currentCallId || !text.trim()) return;
      console.log("updateTranscript2", text, role, isFullSentence, isRealtime);
      this.activeChat = {
        chatId: this.currentCallId,
      };
      try {
        if (isRealtime) {
          // 对于实时文本，们需要更新最后一条 AI 消息，而不是添加新消息
          const transcripts = this.chatList || [];
          const lastMessage = transcripts[transcripts.length - 1];
          console.log(
            "updateTranscript from realtime",
            lastMessage,
            lastMessage
          );

          //   if (
          //     lastMessage &&
          //     lastMessage.role === "assistant" &&
          //     !lastMessage.isComplete
          //   ) {
          //     // 更新现有的未完成消息
          //     lastMessage.content = text;

          //     // 调用 API 更新记录
          //     // await addTranscript({
          //     //   chatId: this.currentCallId,
          //     //   seq: this.chatList.length,
          //     //   msgType: "answer",
          //     //   content: text,
          //     // });
          //   } else {
          console.log(
            "updateTranscript from fullSentence",
            this.chatList,
            text,
            role,
            isFullSentence,
            isRealtime
          );
          if (isFullSentence) {
            this.chatList.push({
              role: "assistant",
              content: text,
            });
          }
          // 调用 API 保存新记录
          await addTranscript({
            chatId: this.currentCallId,
            seq: this.chatList.length,
            msgType: "answer",
            content: text,
          });
          this.currentRealtimeText = "";
          //   }
        } else {
          // 调用 API 保存记录
          console.log(
            "addTranscript",
            this.currentCallId,
            this.chatList.length
          );
          await addTranscript({
            chatId: this.currentCallId,
            seq: this.chatList.length,
            msgType: role === "user" ? "question" : "answer",
            content: text,
          });
        }

        // this.updateCallSummary(text, "");

        // 确保滚动到最新消息
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } catch (error) {
        console.error("updateTranscript error", error);
      }
    },
    async updateCallSummary(text, role) {
      try {
        if (!this.currentCall) return;

        if (this.isCallActive && text.trim()) {
          // 准备历史记录数据
          const transcriptHistory = this.currentCall.transcript.map((item) => ({
            role: item.role,
            content: item.content,
          }));
          const summary = this.currentCall.summary || "";

          const response = await getCallSummary(
            this.currentCall.id,
            transcriptHistory,
            summary
          );

          if (response && response.summary) {
            this.currentCall.summary = response.summary;
            const call = this.callHistory.find(
              (c) => c.id === this.currentCall.id
            );
            if (call) {
              call.summary = response.summary;
            }
          }
        }
      } catch (error) {
        Toast.fail("更新通话总结失败");
      }
    },
    // 检查滚动位置
    checkScroll() {
      if (!this.$refs.callContainer) return;

      const container = this.$refs.callContainer;
      const { scrollTop, scrollHeight, clientHeight } = container;

      // 如果滚动条距离底部超过10px，显示渐变
      console.log("checkScroll", scrollTop, scrollHeight, clientHeight);
      this.showScrollGradient = scrollTop + clientHeight < scrollHeight - 10;
    },

    // 滚动到底部
    scrollToBottom() {
      if (!this.$refs.callContainer) return;

      const container = this.$refs.callContainer;
      this.$nextTick(() => {
        container.scrollTop = container.scrollHeight;
      });
    },
  },
  watch: {
    chatList: {
      handler(newVal, oldVal) {
        // 当聊天列表更新时，检查是否需要滚动到底部
        this.$nextTick(() => {
          this.checkScroll();
        });
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.voice-talk-container {
  box-sizing: border-box;
  width: 100%;
  height: calc(100dvh - 108px);
  padding-bottom: 36px;
  background: linear-gradient(
    180deg,
    #b3cdff60 0%,
    #e3e9ff60 50%,
    #e5e7fa60 100%
  );
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.is-in-weixin {
    height: calc(100vh - 28px);
  }
}

.voice-header {
  padding: 23px 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  img {
    width: 24px;
    display: inline-block;
  }
  .page-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 600;
    white-space: nowrap;
  }
}

.voice-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;

  .avatar-container {
    margin-top: 23%;
    margin-bottom: 36px;
    width: 150px;
    height: 150px;
    .avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .greeting-text {
    .greeting-title {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      color: #000000;
    }

    p {
      margin-top: 12px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 20px;
      line-height: 140%;
      color: #000000;
      text-align: center;
    }
  }
}

.call-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .call-button {
    width: 70px;
    height: 70px;
    background-color: #6db669;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    box-shadow: 0 4px 12px rgba(124, 179, 66, 0.4);
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
    }
  }

  p {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: #00000080;
  }
}

.call-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative; /* 相对定位，用于定位渐变效果 */
  margin-top: 16px;
  overflow: hidden; /* 隐藏溢出内容，避免出现双滚动条 */
}

.call-in-progress {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow-y: auto; /* 只有内部容器可滚动 */
  row-gap: 16px;

  .call-question,
  .call-answer {
    max-width: 100%;

    p {
      width: 95%;
      font-size: 14px;
      line-height: 1.6;
    }
  }

  .call-question {
    p {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #00000080;
    }
  }

  .call-answer {
    p {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #000000;
    }
  }
}

.scroll-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(229, 231, 250, 0.9)
  );
  pointer-events: none; /* 确保不会阻止滚动和点击 */
  z-index: 1;
}

.call-controls {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 20px;
  padding-bottom: 0;
  background-color: transparent;

  .control-button {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      margin-top: 15px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: #00000080;
    }

    .control-button-icon {
      width: 70px;
      height: 70px;
      background: #0000000d;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .control-button-icon-img {
        width: 28px;
        height: 28px;
      }

      &.is-muted {
        background: #ed6969;
      }

      &.is-speaker-on {
        background: #409eff;
      }
    }

    .end-call-icon {
      width: 70px;
      height: 70px;
      background: #f66868;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .close-phone {
      transform: rotate(134.54deg);
    }
  }
}
</style>
